document.addEventListener("DOMContentLoaded", function () {
  const tabsContainer = document.querySelector(".collection-navigation");
  const activeTab = tabsContainer?.querySelector(".collection-navigation__item-link--active");

  if (tabsContainer && activeTab) {
    const offsetLeft = activeTab.offsetLeft;
    const tabWidth = activeTab.offsetWidth;
    const containerWidth = tabsContainer.offsetWidth;

    const scrollPosition = offsetLeft - (containerWidth / 2) + (tabWidth / 2);

    tabsContainer.scrollTo({
      left: scrollPosition,
      behavior: "smooth"
    });
  }
});